import { stats } from '../../../mocks/gossip';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=playful%20pop%20culture%20collage%20of%20gossip%20magazines%2C%20starry%20stage%20lights%20and%20bokeh%20in%20vibrant%20red%20and%20cream%20tones%2C%20artistic%20editorial%20background%20for%20an%20entertainment%20news%20portal%2C%20soft%20dreamy%20atmosphere%2C%20lively%20and%20fun&width=1920&height=1080&seq=hero-bg&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/55 to-background-50"></div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-16 pt-32 text-center md:px-6 md:pb-20 md:pt-40">
        <span className="mb-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-100/90 px-4 py-1.5 text-xs font-medium text-accent-800">
          <i className="ri-flashlight-fill text-sm"></i>
          前排蹲好 · 新瓜速递中
        </span>

        <h1 className="font-heading max-w-4xl text-4xl leading-tight text-foreground-950 md:text-6xl md:leading-tight">
          呱呱吃瓜，围观现场前排蹲
        </h1>

        <p className="mt-5 max-w-2xl text-base text-foreground-700 md:text-lg">
          点开就是吃瓜围观现场，实时直播一手看。弹幕热评、各方回应都在动态更新，一边蹲后续一边等更新，在线吃瓜不落单。
        </p>

        <div className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row sm:items-center sm:rounded-full sm:border sm:border-background-200 sm:bg-background-50/90 sm:p-1.5">
          <label className="sr-only" htmlFor="hero-search">搜索你关心的瓜</label>
          <div className="flex flex-1 items-center gap-2 rounded-full bg-background-50 px-4 py-2.5 sm:bg-transparent sm:px-3 sm:py-0">
            <i className="ri-search-line text-lg text-foreground-400"></i>
            <input
              id="hero-search"
              type="text"
              placeholder="搜索艺人、剧集或事件关键词…"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </div>
          <button className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600">
            前排开搜
          </button>
        </div>

        <div className="mt-12 grid w-full max-w-3xl grid-cols-2 gap-3 md:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-200/70 bg-background-50/80 px-4 py-4 text-center backdrop-blur"
            >
              <div className="font-heading text-2xl text-accent-600 md:text-3xl">{s.value}</div>
              <div className="mt-1 text-xs text-foreground-600 md:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}